import React from "react";
import styles from "./styles.module.css";

/**
 * Reusable loading indicator. Use anywhere you need a consistent loading state.
 *
 * @param {string} [variant='inline'] - 'inline' (in flow) or 'overlay' (covers parent; parent needs position: relative).
 * @param {string} [label='Loading...'] - Text below spinner. Pass empty string to hide.
 */
const Loading = ({ variant = "inline", label = "Loading..." }) => {
  const isOverlay = variant === "overlay";
  return (
    <div
      className={isOverlay ? `${styles.wrap} ${styles.wrapOverlay}` : styles.wrap}
      role="status"
      aria-live="polite"
      aria-label={label || "Loading"}
    >
      <div className={styles.spinner} aria-hidden />
      {label ? <p className={styles.label}>{label}</p> : null}
    </div>
  );
};

export default Loading;
